<template>
  <div class="c54">
    <div class="doc-content">
      <div>
        <p class="c44">
          <span
            style="
              overflow: hidden;
              display: inline-block;
              margin: 0px 0px;
              border: 0px solid #000000;
              transform: rotate(0rad) translateZ(0px);
              -webkit-transform: rotate(0rad) translateZ(0px);
              width: 141.2px;
              height: 63.4px;
            "
            ><img
              alt="Interface gr&aacute;fica do usu&aacute;rio
            Descri&ccedil;&atilde;o gerada automaticamente com confian&ccedil;a m&eacute;dia"
              src="/img/privacy/image2.png"
              style="
                width: 141.2px;
                height: 63.4px;
                margin-left: 0px;
                margin-top: 0px;
                transform: rotate(0rad) translateZ(0px);
                -webkit-transform: rotate(0rad) translateZ(0px);
              "
              title=""
          /></span>
        </p>
      </div>
      <p class="c70 title">
        <span class="c67">POL&Iacute;TICA DE PRIVACIDADE - LGPD</span>
      </p>
      <p class="c37"><span class="c47"></span></p>
      <p class="c34"><span class="c48"></span></p>
      <p class="c6">
        <span class="c2">
          Ao ler esta Pol&iacute;tica de Privacidade, o cliente (USU&Aacute;RIO)
          &eacute; informado sobre a maneira pela qual a RMS TECHNOLOGY coleta,
          processa e protege os dados pessoais que voc&ecirc; pode fornecer
          atrav&eacute;s do site e das plataformas dispon&iacute;veis pela RMS
          TECHNOLOGY.
        </span>
      </p>
      <p class="c21">
        <span class="c2"
          >O cliente deve ler atentamente esta Pol&iacute;tica de Privacidade,
          que foi escrita de forma simples e clara, para facilitar seu
          entendimento e para que possa determinar livre e voluntariamente se
          deseja fornecer seus dados pessoais &agrave; RMS TECHNOLOGY.</span
        >
      </p>
      <p class="c34"><span class="c1"></span></p>
      <h1 class="c0 mt-3">
        <span class="c3"> DEFINI&Ccedil;&Otilde;ES: </span>
      </h1>
      <p class="c16"><span class="c9"></span></p>
      <p class="c60">
        <span class="c2"
          >Para que seja de melhor compreens&atilde;o das
          informa&ccedil;&otilde;es desta pol&iacute;tica, elencamos abaixo as
          defini&ccedil;&otilde;es dos termos utilizados:</span
        >
      </p>
      <p class="c49">
        <span class="c3">Usu&aacute;rio: </span
        ><span class="c2"
          >&eacute; a pessoa que utiliza o site e/ou que visitar&atilde;o as
          plataformas e/ou aplicativos da RMS TECHNOLOGY.</span
        >
      </p>
      <p class="c64">
        <span class="c3">Dado pessoal: </span
        ><span class="c2"
          >informa&ccedil;&atilde;o relacionada a pessoa natural identificada ou
          identific&aacute;vel;</span
        >
      </p>
      <p class="c33">
        <span class="c3">Dado anonimizado: </span
        ><span class="c2"
          >dado de titular que n&atilde;o possa ser identificado, considerando a
          utiliza&ccedil;&atilde;o de meios t&eacute;cnicos razo&aacute;veis e
          dispon&iacute;veis na ocasi&atilde;o de seu tratamento;</span
        >
      </p>
      <p class="c19">
        <span class="c3">Titular: </span
        ><span class="c2"
          >pessoa natural a quem se referem os dados pessoais que s&atilde;o
          objeto de tratamento; </span
        ><span class="c3">Encarregado de dados: </span
        ><span class="c2"
          >pessoa indicada pela empresa para responder questionamentos dos
          titulares dos dados e da Autoridade Nacional de Prote&ccedil;&atilde;o
          de Dados e respons&aacute;vel pelo Programa de Governan&ccedil;a em
          Privacidade.</span
        >
      </p>
      <p class="c32">
        <span class="c3">Controlador: </span
        ><span class="c2"
          >pessoa ou entidade a quem compete as decis&otilde;es referentes ao
          tratamento de dados pessoais.</span
        >
      </p>
      <p class="c52">
        <span class="c3">Operador: </span
        ><span class="c2"
          >pessoa ou entidade que realiza o tratamento de dados pessoais a
          servi&ccedil;o do controlador.</span
        >
      </p>
      <p class="c7">
        <span class="c3">Tratamento: </span
        ><span class="c2"
          >toda opera&ccedil;&atilde;o realizada com dados pessoais, como as que
          se referem a coleta, produ&ccedil;&atilde;o, recep&ccedil;&atilde;o,
          classifica&ccedil;&atilde;o, utiliza&ccedil;&atilde;o, acesso,
          reprodu&ccedil;&atilde;o, transmiss&atilde;o,
          distribui&ccedil;&atilde;o, processamento, arquivamento,
          armazenamento, elimina&ccedil;&atilde;o, avalia&ccedil;&atilde;o ou
          controle da informa&ccedil;&atilde;o, modifica&ccedil;&atilde;o,
          comunica&ccedil;&atilde;o, transfer&ecirc;ncia, difus&atilde;o ou
          extra&ccedil;&atilde;o;</span
        >
      </p>
      <p class="c56">
        <span class="c3">Anonimiza&ccedil;&atilde;o: </span
        ><span class="c2"
          >utiliza&ccedil;&atilde;o de meios t&eacute;cnicos razo&aacute;veis e
          dispon&iacute;veis no momento do tratamento, por meio dos quais um
          dado perde a possibilidade de associa&ccedil;&atilde;o, direta ou
          indireta, a um indiv&iacute;duo;</span
        >
      </p>
      <p class="c18">
        <span class="c3">Consentimento: </span
        ><span class="c2"
          >manifesta&ccedil;&atilde;o livre, informada e inequ&iacute;voca pela
          qual o titular concorda com o tratamento de seus dados pessoais para
          uma finalidade determinada; </span
        ><span class="c3">Compartilhamento: </span
        ><span class="c2"
          >comunica&ccedil;&atilde;o, difus&atilde;o, transfer&ecirc;ncia
          internacional, interconex&atilde;o de dados pessoais ou tratamento
          compartilhado de bancos de dados pessoais por &oacute;rg&atilde;os e
          entidades p&uacute;blicos no cumprimento de suas compet&ecirc;ncias
          legais, ou entre esses e entes privados, reciprocamente, com
          autoriza&ccedil;&atilde;o espec&iacute;fica, para uma ou mais
          modalidades de tratamento permitidas por esses entes p&uacute;blicos,
          ou entre entes privados;</span
        >
      </p>
      <p class="c34"><span class="c50"></span></p>
      <h1 class="c35 mt-3">
        <span class="c3">
          RESPONS&Aacute;VEL PELO PROCESSAMENTO DE SEUS DADOS
        </span>
      </h1>
      <p class="c16"><span class="c9"></span></p>
      <p class="c10">
        <span class="c2">A RMS TECHNOLOGY &eacute; a </span
        ><span class="c3">controladora </span
        ><span class="c2"
          >e respons&aacute;vel pelo tratamento de seus dados, que em caso de
          d&uacute;vidas ou necessidades em rela&ccedil;&atilde;o &agrave;
          prote&ccedil;&atilde;o dos dados, fornece o respectivo </span
        ><span class="c3">contato </span
        ><span class="c2">do seu encarregado de dados:</span>
      </p>
      <p class="c27"><span class="c2">RMS TECNOLOGIA LTDA</span></p>
      <p class="c27">
        <span class="c2">CNPJ sob o n&ordm; 40.307.269/0001-30</span>
      </p>
      <p class="c25">
        <span class="c2"
          >Rua 28 de Agosto, 1556, 3&ordm; andar sala 13, &nbsp;Centro, CEP
          89.270-000 &ndash; Guaramirim &ndash; SC Tel.: 47 9 8896 9292</span
        >
      </p>
      <p class="c0"><span class="c2">E-mail: renan@rmsconsult.com.br</span></p>
      <p class="c45">
        <span class="c2"
          >Maiores informa&ccedil;&otilde;es sobre o encarregado pelo tratamento
          dos dados pessoais tratados pela RMS TECHNOLOGY podem ser obtidas no
          seguinte e-mail: renan@rmsconsult.com.br</span
        >
      </p>
      <p class="c37"><span class="c20"></span></p>
      <p class="c26"><span class="c61"></span></p>
      <h1 class="c35 mt-2">
        <span class="c3">FINALIDADE DO TRATAMENTO DE SEUS DADOS</span>
      </h1>
      <p class="c16"><span class="c9"></span></p>
      <p class="c14">
        <span class="c2"
          >O usu&aacute;rio &eacute; informado de que a RMS TECHNOLOGY
          processar&aacute; os seus dados pessoais atrav&eacute;s de dados
          cadastrais de identifica&ccedil;&atilde;o, de conex&atilde;o e de
          navega&ccedil;&atilde;o, dentro das </span
        ><span class="c3">finalidades </span
        ><span class="c2">assim estabelecidas:</span>
      </p>
      <ol class="c24 lst-kix_list_3-0 start" start="1">
        <li class="c63 li-bullet-0">
          <span class="c2"
            >Possibilitar o acesso do usu&aacute;rio ao site da RMS
            TECHNOLOGY;</span
          >
        </li>
        <li class="c28">
          <span class="c2"
            >Gerenciamento do relacionamento com o usu&aacute;rio atrav&eacute;s
            dos recursos dispon&iacute;veis no site;</span
          >
        </li>
        <li class="c31 c39">
          <span class="c2"
            >Preven&ccedil;&atilde;o de fraudes, com a consequente
            aplica&ccedil;&atilde;o de medidas de seguran&ccedil;a da
            informa&ccedil;&atilde;o;</span
          >
        </li>
        <li class="c63 li-bullet-0">
          <span class="c2"
            >Comunica&ccedil;&atilde;o entre a RMS TECHNOLOGY e o
            usu&aacute;rio;</span
          >
        </li>
        <li class="c23 c31">
          <span class="c2"
            >Realiza&ccedil;&atilde;o de estudos estat&iacute;sticos e de
            mercado, incluindo a an&aacute;lise do comportamento do
            usu&aacute;rio no contexto de sua navega&ccedil;&atilde;o e a
            cria&ccedil;&atilde;o de perfis do usu&aacute;rio por meio da
            integra&ccedil;&atilde;o e processamento conjunto das
            informa&ccedil;&otilde;es obtidas atrav&eacute;s de cookies ou
            tecnologias similares.</span
          >
        </li>
      </ol>
      <p class="c16"><span class="c12"></span></p>
      <h1 class="c59 mt-3">
        <span class="c3">BASE LEGAL PARA O PROCESSAMENTO DE SEUS DADOS</span>
      </h1>
      <p class="c16"><span class="c9"></span></p>
      <p class="c36">
        <span class="c2"
          >A base legal para o tratamento de seus dados pessoais &eacute; o
          consentimento a partir da anu&ecirc;ncia do contrato de
          presta&ccedil;&atilde;o de servi&ccedil;os firmado entre as
          partes.</span
        >
      </p>
      <p class="c38">
        <span class="c2"
          >O site n&atilde;o &eacute; destinado &agrave;
          utiliza&ccedil;&atilde;o por menores de 18 (dezoito) anos e
          incapazes.</span
        >
      </p>
      <p class="c23">
        <span class="c2"
          >O processamento de dados de menores dever&aacute; ser realizado com o
          consentimento espec&iacute;fico e em destaque dado por pelo menos um
          dos pais ou pelo respons&aacute;vel legal, obtendo o conhecimento
          deste procedimento junto ao encarregado de dados da RMS
          TECHNOLOGY.</span
        >
      </p>
      <p class="c65">
        <span class="c2"
          >Na hip&oacute;tese de utiliza&ccedil;&atilde;o dos dados de menores,
          o respons&aacute;vel dever&aacute; consentir com todas as
          condi&ccedil;&otilde;es previstas nesta pol&iacute;tica.</span
        >
      </p>
      <p class="c22">
        <span class="c2"
          >Todas as atividades de tratamento realizadas pela RMS TECHNOLOGY
          contam com controles, sistemas e medidas t&eacute;cnicas e
          administrativas adequadas aos padr&otilde;es de mercado para garantir
          a confidencialidade, integridade e disponibilidade nas </span
        ><span class="c3">finalidades </span
        ><span class="c2"
          >leg&iacute;timas dos dados fornecidos por voc&ecirc;.</span
        >
      </p>
      <p class="c26"><span class="c1"></span></p>
      <h1 class="c0 mt-3">
        <span class="c3">
          DADOS QUE SER&Atilde;O TRATADOS PELA RMS TECHNOLOGY
        </span>
      </h1>
      <p class="c16"><span class="c9"></span></p>
      <p class="c59">
        <span class="c2"
          >A RMS TECHNOLOGY processar&aacute; os seguintes tipos de dados pelos
          usu&aacute;rios, dentro das </span
        ><span class="c3">finalidades</span>
      </p>
      <p class="c29">
        <span class="c2">estabelecidas nesta pol&iacute;tica:</span>
      </p>
      <ol class="c24 lst-kix_list_2-0 start" start="1">
        <li class="c31 c46">
          <span class="c2"
            >Dados de identifica&ccedil;&atilde;o: Nome e sobrenome;</span
          >
        </li>
        <li class="c31 c58">
          <span class="c2"
            >Informa&ccedil;&otilde;es de contato: e-mail, login, senha,
            informa&ccedil;&otilde;es de contato, telefone;</span
          >
        </li>
      </ol>
      <p class="c15"><span class="c12"></span></p>
      <h1 class="c71 mt-3">
        <span class="c3">COMPARTILHAMENTO DE SEUS DADOS</span>
      </h1>
      <p class="c16"><span class="c9"></span></p>
      <p class="c14">
        <span class="c2"
          >Os dados fornecidos atrav&eacute;s do site da RMS TECHNOLOGY </span
        ><span class="c3">poder&atilde;o ser compartilhados </span
        ><span class="c2"
          >para cumprimento da legisla&ccedil;&atilde;o vigente, regulamentos
          aplic&aacute;veis, ordens judiciais, determina&ccedil;&otilde;es
          governamentais, bem como para prote&ccedil;&atilde;o de direitos,
          propriedade ou seguran&ccedil;a dos respectivos titulares dos
          dados.</span
        >
      </p>
      <p class="c66">
        <span class="c2"
          >Al&eacute;m disso, podemos compartilhar os seus dados com
          fornecedores e prestadores de servi&ccedil;os que sustentem a
          infraestrutura de software, hardware e comunica&ccedil;&atilde;o,
          estritamente para a execu&ccedil;&atilde;o de suas atividades
          t&eacute;cnicas, observado o compromisso de confidencialidade destas
          informa&ccedil;&otilde;es.</span
        >
      </p>
      <p class="c6">
        <span class="c2"
          >Todo o acesso conferido das informa&ccedil;&otilde;es fornecidas por
          voc&ecirc; ser&aacute; regulado ao m&iacute;nimo necess&aacute;rio
          &agrave; realiza&ccedil;&atilde;o das </span
        ><span class="c3">finalidades </span
        ><span class="c2">estabelecidas nesta pol&iacute;tica.</span>
      </p>
      <p class="c37"><span class="c1"></span></p>
      <h1 class="c0 mt-3">
        <span class="c3">TEMPO DE ARMAZENAGEM DE SEUS DADOS</span>
      </h1>
      <p class="c16"><span class="c9"></span></p>
      <p class="c56">
        <span class="c2"
          >Todos os dados fornecidos por voc&ecirc; ser&atilde;o mantidos pelo
          tempo necess&aacute;rio a cumprir com as </span
        ><span class="c3">finalidades </span
        ><span class="c2"
          >pelas quais foram coletadas, a menos que voc&ecirc; exer&ccedil;a seu
          direito de revoga&ccedil;&atilde;o de consentimento, observado os
          limites estabelecidos na legisla&ccedil;&atilde;o.</span
        >
      </p>
      <p class="c41">
        <span class="c2"
          >Via de regra, os dados ser&atilde;o mantidos durante os seguintes
          per&iacute;odos:</span
        >
      </p>
      <p class="c23">
        <span class="c2"
          >(I) Dados referentes a registros de aplica&ccedil;&atilde;o para o
          cumprimento de obriga&ccedil;&otilde;es previstas na
          legisla&ccedil;&atilde;o em vigor, sendo, no Brasil, referentes ao
          Marco Civil da Internet (Lei n&ordm; 12.965): 6 (seis) meses, a partir
          da coleta dos dados de registros de aplica&ccedil;&atilde;o;</span
        >
      </p>
      <h1 class="c51 mt-4">
        <span class="c3"> SEUS DIREITOS COMO TITULAR DE DADOS </span>
      </h1>
      <p class="c16"><span class="c9"></span></p>
      <p class="c5">
        <span class="c2"
          >Voc&ecirc; poder&aacute; requisitar ao encarregado de dados da RMS
          TECHNOLOGY, conforme previsto pela legisla&ccedil;&atilde;o, a
          qualquer tempo:</span
        >
      </p>
      <ol class="c24 lst-kix_list_1-0 start" start="1">
        <li class="c57 li-bullet-0">
          <span class="c2">
            Confirma&ccedil;&atilde;o da exist&ecirc;ncia de tratamento de dados
            de sua titularidade;
          </span>
        </li>
        <li class="c69 li-bullet-0">
          <span class="c2">Quais os dados tratados;</span>
        </li>
        <li class="c45 c31 c68">
          <span class="c2"
            >Corre&ccedil;&atilde;o dos dados incompletos, inexatos ou
            desatualizados, observando-se o rito assinalado neste termo;</span
          >
        </li>
        <li class="c31 c62">
          <span class="c2"
            >Anonimiza&ccedil;&atilde;o, bloqueio ou elimina&ccedil;&atilde;o de
            dados desnecess&aacute;rios ou n&atilde;o consentidos, observando-se
            as situa&ccedil;&otilde;es previstas pela legisla&ccedil;&atilde;o
            vigente;</span
          >
        </li>
        <li class="c13">
          <span class="c2"
            >Portabilidade dos dados, observados os segredos comerciais
            eventualmente envolvidos e de acordo com a
            regulamenta&ccedil;&atilde;o do &oacute;rg&atilde;o
            controlador;</span
          >
        </li>
        <li class="c19 c31">
          <span class="c2"
            >A elimina&ccedil;&atilde;o dos dados pessoais tratados com o
            consentimento do titular, observado os limites da
            legisla&ccedil;&atilde;o;</span
          >
        </li>
        <li class="c40 c31">
          <span class="c2"
            >Informa&ccedil;&atilde;o das entidades p&uacute;blicas e privadas
            com as quais o controlador realizou uso compartilhado de
            dados;</span
          >
        </li>
        <li class="c31 c40">
          <span class="c2"
            >Informa&ccedil;&atilde;o sobre a possibilidade de n&atilde;o
            fornecer consentimento e sobre as consequ&ecirc;ncias da
            negativa;</span
          >
        </li>
        <li class="c31 c32">
          <span class="c2"
            >Revoga&ccedil;&atilde;o do consentimento para tratamento dos seus
            dados, observado os limites estabelecidos na
            legisla&ccedil;&atilde;o.</span
          >
        </li>
      </ol>
      <p class="c17"><span class="c12"></span></p>
      <h1 class="c0 mt-3">
        <span class="c3"> SEGURAN&Ccedil;A DOS SEUS DADOS </span>
      </h1>
      <p class="c16"><span class="c9"></span></p>
      <p class="c36">
        <span class="c2"
          >Todas os dados pessoais fornecidos por voc&ecirc; ser&atilde;o
          guardados na base de dados da RMS TECHNOLOGY ou em base de dados
          mantidas &ldquo;na nuvem&rdquo; pelos fornecedores de servi&ccedil;os
          contratados, os quais proporcionam o mesmo grau de
          prote&ccedil;&atilde;o de dados pessoais fornecidos pela RMS
          TECHNOLOGY. A RMS TECHNOLOGY e seus fornecedores utilizam
          v&aacute;rios procedimentos de seguran&ccedil;a para proteger a
          confidencialidade, seguran&ccedil;a e integridade de seus dados
          pessoais, adotando medidas de preven&ccedil;&atilde;o, com o objetivo
          de mitigar a ocorr&ecirc;ncia de eventuais danos.</span
        >
      </p>
      <p class="c26"><span class="c1"></span></p>
      <h1 class="c0 mt-3">
        <span class="c3"> OBRIGA&Ccedil;&Otilde;ES DO TITULAR </span>
      </h1>
      <p class="c16"><span class="c9"></span></p>
      <p class="c36">
        <span class="c2"
          >Al&eacute;m de observar as demais condi&ccedil;&otilde;es constantes
          nesta pol&iacute;tica, voc&ecirc; deve se responsabilizar pelo uso que
          fizer dos seus dados, disponibilizados atrav&eacute;s do site, bem
          como preencher devidamente os seus dados para cadastro de acesso e
          comunica&ccedil;&atilde;o requeridos.</span
        >
      </p>
      <p class="c7">
        <span class="c2"
          >O fornecimento de informa&ccedil;&otilde;es falsas, excessivas ou
          imprecisas fornecidas ao site, ser&atilde;o de sua responsabilidade,
          incluindo &agrave;queles relativos aos danos causados, diretos ou
          indiretos, &agrave; RMS TECHNOLOGY.</span
        >
      </p>
      <h1 class="c51 mt-3">
        <span class="c3">
          VALIDADE E ALTERA&Ccedil;&Otilde;ES DA POL&Iacute;TICA DE PRIVACIDADE
        </span>
      </h1>
      <p class="c16"><span class="c9"></span></p>
      <p class="c0">
        <span class="c2">
          A presente Pol&iacute;tica de Privacidade passa a vigorar a partir de
          18 de agosto &nbsp;de 2020.
        </span>
      </p>
      <p class="c43">
        <span class="c2"
          >A RMS TECHNOLOGY se reserva no direito de modificar atrav&eacute;s do
          seu encarregado de dados, a qualquer momento, a presente
          Pol&iacute;tica de Privacidade, mediante pr&eacute;via
          comunica&ccedil;&atilde;o aos usu&aacute;rios.</span
        >
      </p>
      <p class="c55">
        <span class="c2"
          >O aviso ser&aacute; encaminhado a endere&ccedil;o eletr&ocirc;nico ou
          aviso durante o primeiro acesso a plataforma ou quando houver
          altera&ccedil;&otilde;es.</span
        >
      </p>
      <p class="c55">
        <span class="c2"
          >Caso o usu&aacute;rio n&atilde;o concorde com a
          revis&atilde;o/altera&ccedil;&atilde;o realizada na pol&iacute;tica,
          deve parar de utilizar os servi&ccedil;os da RMS TECHNOLOGY.</span
        >
      </p>
      <p class="c37"><span class="c11"></span></p>
      <p class="c37"><span class="c11"></span></p>
      <p class="c26"><span class="c42"></span></p>
      <p class="c0">
        <span class="c2">Guaramirim &ndash; SC, 18 de agosto de 2020.</span>
      </p>
      <p class="c37"><span class="c11"></span></p>
      <p class="c37"><span class="c11"></span></p>
      <p class="c30"><span class="c8"></span></p>
      <p class="c53 mb-3">
        <span class="c2">[ ] Li e Aceito - USU&Aacute;RIO</span>
      </p>
      <div>
        <p class="c44">
          <span
            style="
              overflow: hidden;
              display: inline-block;
              margin: 0px 0px;
              border: 0px solid #000000;
              transform: rotate(0rad) translateZ(0px);
              -webkit-transform: rotate(0rad) translateZ(0px);
              width: 231.13px;
              height: 61.6px;
            "
            ><img
              alt=""
              src="/img/privacy/image1.png"
              style="
                width: 231.13px;
                height: 61.6px;
                margin-left: -0px;
                margin-top: -0px;
                transform: rotate(0rad) translateZ(0px);
                -webkit-transform: rotate(0rad) translateZ(0px);
              "
              title=""
          /></span>
        </p>
        <p class="c4"><span class="c20"></span></p>
        <p class="c4"><span class="c20"></span></p>
        <p class="c4"><span class="c20"></span></p>
      </div>
    </div>
  </div>
</template>
    <script>
export default {
  components: {},
  props: {},
};
</script>
<style scoped>
@media (min-width: 768px) {
  .doc-content {
    width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
}

.lst-kix_list_2-6 > li:before {
  content: "\002022   ";
}
.lst-kix_list_2-7 > li:before {
  content: "\002022   ";
}
ol.lst-kix_list_1-0 {
  list-style-type: none;
}
.lst-kix_list_2-4 > li:before {
  content: "\002022   ";
}
.lst-kix_list_2-5 > li:before {
  content: "\002022   ";
}
.lst-kix_list_2-8 > li:before {
  content: "\002022   ";
}
ol.lst-kix_list_3-0 {
  list-style-type: none;
}
.lst-kix_list_3-0 > li:before {
  content: "(" counter(lst-ctn-kix_list_3-0, upper-roman) ") ";
}
.lst-kix_list_3-1 > li:before {
  content: "\002022   ";
}
.lst-kix_list_3-2 > li:before {
  content: "\002022   ";
}
ul.lst-kix_list_3-7 {
  list-style-type: none;
}
ul.lst-kix_list_3-8 {
  list-style-type: none;
}
ol.lst-kix_list_3-0.start {
  counter-reset: lst-ctn-kix_list_3-0 0;
}
ul.lst-kix_list_1-3 {
  list-style-type: none;
}
ul.lst-kix_list_3-1 {
  list-style-type: none;
}
.lst-kix_list_3-5 > li:before {
  content: "\002022   ";
}
ul.lst-kix_list_1-4 {
  list-style-type: none;
}
ul.lst-kix_list_3-2 {
  list-style-type: none;
}
ul.lst-kix_list_1-1 {
  list-style-type: none;
}
.lst-kix_list_3-4 > li:before {
  content: "\002022   ";
}
ul.lst-kix_list_1-2 {
  list-style-type: none;
}
ul.lst-kix_list_1-7 {
  list-style-type: none;
}
.lst-kix_list_3-3 > li:before {
  content: "\002022   ";
}
ul.lst-kix_list_3-5 {
  list-style-type: none;
}
ul.lst-kix_list_1-8 {
  list-style-type: none;
}
ul.lst-kix_list_3-6 {
  list-style-type: none;
}
ul.lst-kix_list_1-5 {
  list-style-type: none;
}
ul.lst-kix_list_3-3 {
  list-style-type: none;
}
ul.lst-kix_list_1-6 {
  list-style-type: none;
}
ul.lst-kix_list_3-4 {
  list-style-type: none;
}
.lst-kix_list_3-8 > li:before {
  content: "\002022   ";
}
.lst-kix_list_2-0 > li {
  counter-increment: lst-ctn-kix_list_2-0;
}
.lst-kix_list_3-6 > li:before {
  content: "\002022   ";
}
.lst-kix_list_3-7 > li:before {
  content: "\002022   ";
}
ol.lst-kix_list_2-0 {
  list-style-type: none;
}
ul.lst-kix_list_2-8 {
  list-style-type: none;
}
ul.lst-kix_list_2-2 {
  list-style-type: none;
}
.lst-kix_list_1-0 > li:before {
  content: "(" counter(lst-ctn-kix_list_1-0, upper-roman) ") ";
}
ul.lst-kix_list_2-3 {
  list-style-type: none;
}
ul.lst-kix_list_2-1 {
  list-style-type: none;
}
ul.lst-kix_list_2-6 {
  list-style-type: none;
}
.lst-kix_list_1-1 > li:before {
  content: "\002022   ";
}
.lst-kix_list_1-2 > li:before {
  content: "\002022   ";
}
ol.lst-kix_list_2-0.start {
  counter-reset: lst-ctn-kix_list_2-0 0;
}
ul.lst-kix_list_2-7 {
  list-style-type: none;
}
ul.lst-kix_list_2-4 {
  list-style-type: none;
}
ul.lst-kix_list_2-5 {
  list-style-type: none;
}
.lst-kix_list_1-3 > li:before {
  content: "\002022   ";
}
.lst-kix_list_1-4 > li:before {
  content: "\002022   ";
}
ol.lst-kix_list_1-0.start {
  counter-reset: lst-ctn-kix_list_1-0 0;
}
.lst-kix_list_1-0 > li {
  counter-increment: lst-ctn-kix_list_1-0;
}
.lst-kix_list_3-0 > li {
  counter-increment: lst-ctn-kix_list_3-0;
}
.lst-kix_list_1-7 > li:before {
  content: "\002022   ";
}
.lst-kix_list_1-5 > li:before {
  content: "\002022   ";
}
.lst-kix_list_1-6 > li:before {
  content: "\002022   ";
}
li.li-bullet-0:before {
  margin-left: -36pt;
  white-space: nowrap;
  display: inline-block;
  min-width: 36pt;
}
.lst-kix_list_2-0 > li:before {
  content: "(" counter(lst-ctn-kix_list_2-0, upper-roman) ") ";
}
.lst-kix_list_2-1 > li:before {
  content: "\002022   ";
}
.lst-kix_list_1-8 > li:before {
  content: "\002022   ";
}
.lst-kix_list_2-2 > li:before {
  content: "\002022   ";
}
.lst-kix_list_2-3 > li:before {
  content: "\002022   ";
}
ol {
  margin: 0;
  padding: 0;
}
table td,
table th {
  padding: 0;
}
.c28 {
  margin-left: 5.1pt;
  padding-top: 2.6pt;
  list-style-position: inside;
  text-indent: 45pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: justify;
  margin-right: 5.7pt;
}
.c13 {
  margin-left: 5.1pt;
  padding-top: 0pt;
  list-style-position: inside;
  text-indent: 45pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: left;
  margin-right: 6pt;
}
.c67 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 12pt;
  font-family: "Trebuchet MS";
  font-style: normal;
}
.c47 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 15pt;
  font-family: "Trebuchet MS";
  font-style: normal;
}
.c8 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 13pt;
  font-family: "Verdana";
  font-style: normal;
}
.c2 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Verdana";
  font-style: normal;
}
.c9 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 15.5pt;
  font-family: "Trebuchet MS";
  font-style: normal;
}
.c11 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 14pt;
  font-family: "Verdana";
  font-style: normal;
}
.c61 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 9pt;
  font-family: "Verdana";
  font-style: normal;
}
.c42 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11.5pt;
  font-family: "Verdana";
  font-style: normal;
}
.c50 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 12.5pt;
  font-family: "Verdana";
  font-style: normal;
}
.c20 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Verdana";
  font-style: normal;
}
.c3 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Trebuchet MS";
  font-style: normal;
}
.c48 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 14.5pt;
  font-family: "Trebuchet MS";
  font-style: normal;
}
.c1 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 13.5pt;
  font-family: "Verdana";
  font-style: normal;
}
.c12 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 20pt;
  font-family: "Verdana";
  font-style: normal;
}
.c10 {
  margin-left: 5.1pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: justify;
  margin-right: 5.7pt;
}
.c32 {
  margin-left: 5.1pt;
  padding-top: 0.2pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: left;
  margin-right: 5.7pt;
}
.c6 {
  margin-left: 5.1pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: justify;
  margin-right: 6pt;
}
.c57 {
  margin-left: 23.1pt;
  padding-top: 0pt;
  padding-left: 18pt;
  padding-bottom: 0pt;
  line-height: 1.1125;
  text-align: left;
}
/* .c70 {
  margin-left: 123pt;
  padding-top: 5pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: center;
  margin-right: 123.7pt;
} */
.c70 {
  padding-top: 5pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: center;
}
.c23 {
  margin-left: 5.1pt;
  padding-top: 2.5pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: justify;
  margin-right: 5.8pt;
}
.c33 {
  margin-left: 5.1pt;
  padding-top: 2.4pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: left;
  margin-right: 5.7pt;
}
.c46 {
  margin-left: 5.1pt;
  padding-top: 2.6pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: justify;
  margin-right: 5.7pt;
}
.c69 {
  margin-left: 23.1pt;
  padding-top: 2.6pt;
  padding-left: 18pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
}
.c14 {
  margin-left: 5.1pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: justify;
  margin-right: 5.6pt;
}
.c65 {
  margin-left: 5.1pt;
  padding-top: 4.3pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: justify;
  margin-right: 6pt;
}
.c53 {
  /* margin-left: 103pt; */
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: center;
  /* margin-right: 123.7pt; */
}
.c55 {
  margin-left: 5.1pt;
  padding-top: 0.2pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: left;
  margin-right: 5.5pt;
}
.c56 {
  margin-left: 5.1pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: justify;
  margin-right: 6pt;
}
.c60 {
  margin-left: 5.1pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: justify;
  margin-right: 6.1pt;
}
.c5 {
  margin-left: 5.1pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: left;
  margin-right: 2.2pt;
}
.c62 {
  margin-left: 5.1pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: left;
  margin-right: 5.8pt;
}
.c63 {
  margin-left: 23.1pt;
  padding-top: 0.2pt;
  padding-left: 18pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: justify;
}
.c58 {
  margin-left: 5.1pt;
  padding-top: 0.1pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: justify;
  margin-right: 5.8pt;
}
.c36 {
  margin-left: 5.1pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: justify;
  margin-right: 5.8pt;
}
.c39 {
  margin-left: 5.1pt;
  padding-top: 0.2pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: justify;
  margin-right: 6.2pt;
}
.c66 {
  margin-left: 5.1pt;
  padding-top: 0.3pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: justify;
  margin-right: 5.7pt;
}
.c27 {
  margin-left: 5.1pt;
  padding-top: 0.1pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: left;
  margin-right: 246.9pt;
}
.c21 {
  margin-left: 5.1pt;
  padding-top: 0.1pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: justify;
  margin-right: 6.1pt;
}
.c49 {
  margin-left: 5.1pt;
  padding-top: 0.2pt;
  padding-bottom: 0pt;
  line-height: 1.1666666666666667;
  text-align: justify;
  margin-right: 6pt;
}
.c19 {
  margin-left: 5.1pt;
  padding-top: 0.1pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: left;
  margin-right: 5.8pt;
}
.c7 {
  margin-left: 5.1pt;
  padding-top: 0.1pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: justify;
  margin-right: 5.7pt;
}
.c18 {
  margin-left: 5.1pt;
  padding-top: 0.1pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: left;
  margin-right: 5.2pt;
}
.c25 {
  margin-left: 5.1pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: left;
  margin-right: 57.9pt;
}
.c40 {
  margin-left: 5.1pt;
  padding-top: 0.2pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: left;
  margin-right: 5.8pt;
}
.c22 {
  margin-left: 5.1pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: justify;
  margin-right: 5.7pt;
}
.c51 {
  margin-left: 5.1pt;
  padding-top: 5pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
}
.c43 {
  margin-left: 5.1pt;
  padding-top: 2.6pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: left;
}
.c37 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
  height: 11pt;
}
.c4 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 0.06;
  text-align: left;
  height: 11pt;
}
.c26 {
  padding-top: 0.1pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
  height: 11pt;
}
.c35 {
  margin-left: 5.1pt;
  padding-top: 5.5pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: justify;
}
.c52 {
  margin-left: 5.1pt;
  padding-top: 0.1pt;
  padding-bottom: 0pt;
  line-height: 1.1791666666666667;
  text-align: left;
}
.c45 {
  margin-left: 5.1pt;
  padding-top: 2.5pt;
  padding-bottom: 0pt;
  line-height: 1.1875;
  text-align: left;
}
.c15 {
  padding-top: 0.5pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
  height: 11pt;
}
.c0 {
  margin-left: 5.1pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
}
.c38 {
  margin-left: 5.1pt;
  padding-top: 0.2pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: justify;
}
.c29 {
  margin-left: 5.1pt;
  padding-top: 2.4pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: justify;
}
.c30 {
  padding-top: 0.4pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
  height: 11pt;
}
.c34 {
  padding-top: 0.2pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
  height: 11pt;
}
.c16 {
  padding-top: 0.3pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
  height: 11pt;
}
.c17 {
  padding-top: 0.6pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
  height: 11pt;
}
.c64 {
  margin-left: 5.1pt;
  padding-top: 0.4pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
}
.c41 {
  margin-left: 5.1pt;
  padding-top: 0.3pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: justify;
}
.c71 {
  margin-left: 5.1pt;
  padding-top: 0.1pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
}
.c59 {
  margin-left: 5.1pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: justify;
}
.c44 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 0.06;
  text-align: left;
}
.c54 {
  background-color: #ffffff;
  /* background-color: #1e1e2f; */
  width: 100%;
  /* max-width: 451pt; */
  /* padding: 72pt 72pt 72pt 72pt; */
}
.c24 {
  padding: 0;
  margin: 0;
}
.c31 {
  list-style-position: inside;
  text-indent: 45pt;
}
.c68 {
  margin-right: 5.7pt;
}
.title {
  padding-top: 5pt;
  color: #000000;
  font-weight: 700;
  font-size: 12pt;
  padding-bottom: 0pt;
  font-family: "Trebuchet MS";
  line-height: 1;
  text-align: center;
}
.subtitle {
  padding-top: 18pt;
  color: #666666;
  font-size: 24pt;
  padding-bottom: 4pt;
  font-family: "Georgia";
  line-height: 1;
  page-break-after: avoid;
  font-style: italic;
  text-align: left;
}
li {
  color: #000000;
  font-size: 11pt;
  font-family: "Verdana";
}
p {
  margin: 0;
  color: #000000;
  font-size: 11pt;
  font-family: "Verdana";
}
h1 {
  padding-top: 0pt;
  color: #000000;
  font-weight: 700;
  font-size: 11pt;
  padding-bottom: 0pt;
  font-family: "Trebuchet MS";
  line-height: 1;
  text-align: left;
}
h2 {
  padding-top: 18pt;
  color: #000000;
  font-weight: 700;
  font-size: 18pt;
  padding-bottom: 4pt;
  font-family: "Verdana";
  line-height: 1;
  page-break-after: avoid;
  text-align: left;
}
h3 {
  padding-top: 14pt;
  color: #000000;
  font-weight: 700;
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: "Verdana";
  line-height: 1;
  page-break-after: avoid;
  text-align: left;
}
h4 {
  padding-top: 12pt;
  color: #000000;
  font-weight: 700;
  font-size: 12pt;
  padding-bottom: 2pt;
  font-family: "Verdana";
  line-height: 1;
  page-break-after: avoid;
  text-align: left;
}
h5 {
  padding-top: 11pt;
  color: #000000;
  font-weight: 700;
  font-size: 11pt;
  padding-bottom: 2pt;
  font-family: "Verdana";
  line-height: 1;
  page-break-after: avoid;
  text-align: left;
}
h6 {
  padding-top: 10pt;
  color: #000000;
  font-weight: 700;
  font-size: 10pt;
  padding-bottom: 2pt;
  font-family: "Verdana";
  line-height: 1;
  page-break-after: avoid;
  text-align: left;
}
</style>